export enum POSPaymentStateStatus {
    all = 'all',
    successful = 'successful',
    failed = 'failed'
}
